<span>
  <a
    (click)="navigateToGlossaryOfTerms()"
    matTooltip="See definition"
    class="instruction-step-anchor"
    [ngStyle]="{
      color: isHovering ? env['colors']['tool_btn_active'] : 'black',
    }"
    (mouseover)="isHovering = true"
    (mouseout)="isHovering = false"
    >{{ text }}</a
  >
  <!-- {{ appendedText }} -->
  <i
    *ngIf="tooltipMessage"
    class="fa-solid fa-circle-info tooltipIcon"
    [matTooltip]="tooltipMessage"
    matTooltipPosition="right"
  ></i>
</span>
